module.exports = __webpack_public_path__ + "static/media/detail4.3fb54d51.jpg";